export default "__VITE_PUBLIC_ASSET__9f41333c__"